/**
 * Created by Bob.Bao on 2017/12/18.
 */
import apis from '../apis'
import * as types from '../mutation-types'

const state = {
  bids: [],
  activeBid: {},
  pageNum: 1,
  pageSize: 10,
  totals: 0
}
const getters = {
  bids: state => state.bids,
  pageNum: state => state.pageNum,
  pageSize: state => state.pageSize,
  totals: state => state.totals
}

const actions = {
  getPageBids({ commit, state }){
    apis.getBids({ pageNum: state.pageNum, pageSize: state.pageSize }, bids => {
      commit(types.PAGE_BIDS, bids)
    }, err => {
      alert(err)
    })
  },
  pageSizeChange({ commit, state }, pageSize){
    apis.getBids({ pageNum: state.pageNum, pageSize: pageSize }, bids => {
      commit(types.PAGE_BIDS, bids)
    }, err => {
      alert(err)
    })
  },
  currentPageChange( {commit, state}, pageNum ){
    apis.getBids({ pageNum: pageNum, pageSize: state.pageSize }, bids => {
      commit(types.PAGE_BIDS, bids)
    }, err => {
      alert(err)
    })
  }
}

const mutations = {
  [types.PAGE_BIDS] ( state, payload ){
    state.bids = payload.recordList
    state.totals = payload.totals
    state.pageNum = payload.pageNo
    state.pageSize = payload.pageSize
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/bids.js